import axios from 'axios';
import qs from 'querystring';
import csrfToken from '../../shared/meta';

export default function signInUser(email, password) {
  const headers = {
    'X-CSRF-TOKEN': csrfToken(),
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  const payload = {};
  payload['user[email]'] = email;
  payload['user[password]'] = password;
  payload['user[remember_me]'] = 1;

  return axios.post('/users/sign_in', qs.stringify(payload), { headers });
}
